export const SAVE_FEATURED_POSTS = `GET_FEATURED_POSTS`
export const SAVE_ALL_POSTS = `SAVE_ALL_POSTS`
export const GET_ALL_POSTS = `GET_ALL_POSTS`

export const SAVE_ALL_TOPICS = `SAVE_ALL_TOPICS`
export const GET_ALL_TOPICS = `GET_ALL_TOPICS`

export const SELECT_POST = `SELECT_POST`
export const SELECT_TOPIC = `SELECT_TOPIC`
export const SELECT_PROFILE = `SELECT_PROFILE`

export const ACCOUNT_REGISTER = `ACCOUNT_REGISTER`
export const ACCOUNT_LOGIN = `ACCOUNT_LOGIN`
export const ACCOUNT_LOGOUT = `ACCOUNT_LOGOUT`

export const SET_LOGIN_TOKEN = `SET_LOGIN_TOKEN`
export const SET_DECODED_ACCOUNT = `SET_DECODED_ACCOUNT`
// cospace action types -------------------------------------------------------
export const GET_ALL_SPACES = `GET_ALL_SPACES`
export const GET_ONE_SPACE = `GET_ONE_SPACE`
export const GET_USER_PROFILE = `GET_USER_PROFILE`

export const GET_USER_REVIEW_HISTORY = `GET_USER_REVIEW_HISTORY`
export const GET_USER_COSPACE_LIST = `GET_USER_COSPACE_LIST`

export const SET_TOKEN = `SET_TOKEN`
export const SET_ACTIVE_USER = `SET_ACTIVE_USER`


export const SET_FILTER_KEY = `SET_FILTER_KEY`

export const SET_FILTER_CITY = `SET_FILTER_CITY`
export const SET_FILTER_MOST_REVIEW = `SET_FILTER_MOST_REVIEW`

export const GET_FILTERED_LIST = `GET_FILTERED_LIST`
export const DESTROY_TOKEN = `DESTROY_TOKEN`

// export const ADD_REVIEW = `ADD_REVIEW`




export const SUBMIT_NEW_POST = `SUBMIT_NEW_POST`

export const LOADING_TRUE = `LOADING_TRUE`
export const LOADING_FALSE = `LOADING_FALSE`

export const HANDLE_ERROR = `HANDLE_ERROR`



// WEBPACK FOOTER //
// ./src/redux/actions/types.js